<template>
  <horizontal-scroll class="watch-list">
    <router-link
      to="/stock"
      v-if="isWatchListEmpty"
      class="watch-list__add-button button filled"
      >{{ $t("add instrument") }}</router-link
    >
    <button
      class="button watch-list__button"
      v-for="listItem in watchList"
      :key="listItem.instrument"
    >
      <div class="button__container">
        <div class="row align-center">
          <h4 class="button__title">{{ getShortenedName(listItem.issuer) }}</h4>
          <p class="button__text_muted">{{ listItem.instrument }}</p>
        </div>
        <div class="row w100 align-center justify-between">
          <p class="button__currency">
            {{ getPrice(listItem) }}
            <span
              class="button__currency_green"
              >{{ /* Здесь должны быть данные о доходности бумаги */ }}</span
            >
          </p>
          <a
            class="button__delete"
            @click="handleWatchListDelete"
            :id="listItem.instrument"
            ><div class="button__delete-icon" :id="listItem.instrument"></div
          ></a>
        </div>
      </div>
    </button>
  </horizontal-scroll>
</template>

<script>
import { mapGetters } from "vuex";
import currencies from "@/config/currencies";
import HorizontalScroll from "@/components/ui-kit/HorizontalScroll";

export default {
  components: {
    "horizontal-scroll": HorizontalScroll
  },
  computed: {
    ...mapGetters(["watchList", "isWatchListLoading", "isWatchListEmpty"])
  },
  methods: {
    getPrice(security) {
      let price;
      let currency;
      try {
        price = security.actualData.price;
      } catch {
        price = "";
      }
      try {
        currency = security.actualData.currency;
      } catch {
        currency = "";
      }
      // Если у бумаги не указана валюта, то не отображаем ее, иначе ищем знак валюты в конфигурационном файле
      let sign = "";
      if (currencies[currency] !== undefined) {
        sign = currencies[currency].sign;
      } else if (currency === null) {
        sign = "";
      } else {
        sign = currency;
      }
      price = price ? price : "0";
      return `${price} ${sign}`;
    },
    getShortenedName(name) {
      if (name && name.length > 19) {
        return name.slice(0, 20) + "...";
      } else {
        return name;
      }
    },
    handleWatchListDelete(e) {
      this.$store.dispatch("unsubscribeToSecurity", e.target.id);
    }
  },
  mounted() {
    this.$store.dispatch("fetchWatchList");
  }
};
</script>

<style scoped>
.watch-list__button {
  min-width: 209px;
  min-height: 65px;
}

.watch-list__button {
  margin-right: 15px;
}

.watch-list__add-button.button {
  max-width: 250px;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #5ac480;
  border: 1px solid #5ac480;
}

.button {
  min-height: 65px;
  min-width: 209px;
  display: inline-block;
  box-sizing: border-box;
}

.button__container {
  min-height: 65px;
  min-width: 209px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  box-sizing: border-box;
}

.button:hover {
  background-color: transparent;
}

.button__title {
  font-size: 15px;
  font-weight: normal;
  color: #ffffff;
  word-wrap: normal;
}

.button__text_muted {
  margin-left: 10px;
  font-size: 13px;
  color: #acb5c5;
}

.button__currency {
  font-size: 15px;
}

.button__currency_green {
  color: #5ac480;
}

.button__delete {
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: red;
  opacity: 0;
  transition: 0.5s;
}

.button__delete > .button__delete-icon {
  margin: auto;
  width: 10px;
  height: 3px;
  background-color: white;
}

.button__container:hover .button__delete {
  opacity: 1;
}

@media all and (max-width: 1300px) {
  .button__title {
    font-size: 13px;
  }

  .button__text_muted {
    font-size: 11px;
  }

  .button__currency {
    font-size: 13px;
  }
}
</style>
